export default "__VITE_ASSET__1cb04f3c__"